package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Peru Flag (32x24dp)
 *
 * - ISO Alpha-2: PE
 * - ISO Alpha-3: PER
 * - ISO Numeric: 604
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Peru: ImageVector by lazy {
    ImageVector.Builder(
        name = "Peru:PE:PER:604:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8f, 0f)
                horizontalLineTo(25f)
                verticalLineTo(24f)
                horizontalLineTo(8f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50101)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(24f, 0f)
                horizontalLineTo(32f)
                verticalLineTo(24f)
                horizontalLineTo(24f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50101)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(8f)
                verticalLineTo(24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA2BB6A))) {
                moveTo(15.741f, 8.745f)
                lineTo(15.775f, 9.107f)
                curveTo(14.776f, 9.208f, 14.237f, 8.72f, 14.237f, 7.708f)
                curveTo(14.237f, 6.703f, 14.765f, 6.169f, 15.757f, 6.163f)
                lineTo(15.759f, 6.526f)
                curveTo(14.955f, 6.531f, 14.585f, 6.906f, 14.585f, 7.708f)
                curveTo(14.585f, 8.501f, 14.943f, 8.826f, 15.741f, 8.745f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA2BB6A))) {
                moveTo(16.184f, 8.745f)
                lineTo(16.15f, 9.107f)
                curveTo(17.149f, 9.208f, 17.688f, 8.72f, 17.688f, 7.708f)
                curveTo(17.688f, 6.703f, 17.16f, 6.169f, 16.168f, 6.163f)
                lineTo(16.166f, 6.526f)
                curveTo(16.97f, 6.531f, 17.34f, 6.906f, 17.34f, 7.708f)
                curveTo(17.34f, 8.501f, 16.981f, 8.826f, 16.184f, 8.745f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE31D1C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.14f, 17.123f)
                curveTo(14.852f, 17.226f, 12.906f, 17.123f, 12.906f, 17.123f)
                verticalLineTo(17.665f)
                horizontalLineTo(14.196f)
                curveTo(14.627f, 17.665f, 14.79f, 17.742f, 14.939f, 17.813f)
                curveTo(15.066f, 17.873f, 15.183f, 17.928f, 15.445f, 17.928f)
                curveTo(15.955f, 17.928f, 15.946f, 17.548f, 15.938f, 17.232f)
                curveTo(15.937f, 17.195f, 15.936f, 17.158f, 15.936f, 17.123f)
                curveTo(15.936f, 16.989f, 15.957f, 16.914f, 15.973f, 16.855f)
                curveTo(15.997f, 16.771f, 16.011f, 16.721f, 15.936f, 16.575f)
                curveTo(15.81f, 16.329f, 14.607f, 16.362f, 14.607f, 16.575f)
                curveTo(14.607f, 16.676f, 14.79f, 16.78f, 14.952f, 16.874f)
                curveTo(15.134f, 16.978f, 15.291f, 17.069f, 15.14f, 17.123f)
                close()
                moveTo(16.889f, 17.123f)
                curveTo(17.176f, 17.226f, 19.123f, 17.123f, 19.123f, 17.123f)
                verticalLineTo(17.665f)
                horizontalLineTo(17.832f)
                curveTo(17.402f, 17.665f, 17.239f, 17.742f, 17.09f, 17.813f)
                curveTo(16.963f, 17.873f, 16.846f, 17.928f, 16.584f, 17.928f)
                curveTo(16.074f, 17.928f, 16.083f, 17.548f, 16.091f, 17.232f)
                curveTo(16.092f, 17.195f, 16.093f, 17.158f, 16.093f, 17.123f)
                curveTo(16.093f, 16.989f, 16.072f, 16.914f, 16.055f, 16.855f)
                curveTo(16.032f, 16.771f, 16.018f, 16.721f, 16.093f, 16.575f)
                curveTo(16.219f, 16.329f, 17.421f, 16.362f, 17.421f, 16.575f)
                curveTo(17.421f, 16.676f, 17.239f, 16.78f, 17.076f, 16.874f)
                curveTo(16.895f, 16.978f, 16.737f, 17.069f, 16.889f, 17.123f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF00A854)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.407f, 17.175f)
                curveTo(16.407f, 17.175f, 17.926f, 17.024f, 18.27f, 16.476f)
                curveTo(18.613f, 15.928f, 19.185f, 14.993f, 19.386f, 14.767f)
                curveTo(19.588f, 14.54f, 19.601f, 15.09f, 19.601f, 15.09f)
                curveTo(19.601f, 15.09f, 19.933f, 15.561f, 19.933f, 14.959f)
                curveTo(19.933f, 14.357f, 19.697f, 14.777f, 19.386f, 13.872f)
                curveTo(19.076f, 12.966f, 18.902f, 12.077f, 18.989f, 11.943f)
                curveTo(19.076f, 11.808f, 19.283f, 12.077f, 19.283f, 11.943f)
                curveTo(19.283f, 11.808f, 19.283f, 11.545f, 19.283f, 11.545f)
                lineTo(19.601f, 11.943f)
                lineTo(19.933f, 11.817f)
                curveTo(19.933f, 11.817f, 20.206f, 12.402f, 20.374f, 12.583f)
                curveTo(20.542f, 12.764f, 20.641f, 12.34f, 20.592f, 11.943f)
                curveTo(20.542f, 11.545f, 19.933f, 11.545f, 19.933f, 11.545f)
                curveTo(19.933f, 11.545f, 19.153f, 11.125f, 19.153f, 10.948f)
                curveTo(19.153f, 10.772f, 19.49f, 10.825f, 19.49f, 10.825f)
                lineTo(19.386f, 10.279f)
                curveTo(19.386f, 10.279f, 19.665f, 10.611f, 19.799f, 10.445f)
                curveTo(19.933f, 10.279f, 19.601f, 9.988f, 19.601f, 9.988f)
                horizontalLineTo(20.13f)
                verticalLineTo(9.733f)
                lineTo(20.374f, 9.87f)
                lineTo(20.13f, 9.312f)
                curveTo(20.13f, 9.312f, 19.413f, 9.42f, 19.283f, 9.312f)
                curveTo(19.153f, 9.204f, 18.742f, 8.783f, 18.742f, 8.783f)
                verticalLineTo(8.583f)
                horizontalLineTo(18.506f)
                lineTo(18.742f, 8.183f)
                verticalLineTo(7.545f)
                lineTo(19.601f, 7.716f)
                verticalLineTo(7.245f)
                curveTo(19.601f, 7.245f, 20.809f, 7.834f, 20.592f, 8.309f)
                curveTo(20.374f, 8.783f, 20.374f, 9.312f, 20.374f, 9.312f)
                verticalLineTo(9.733f)
                curveTo(20.374f, 9.733f, 20.41f, 9.604f, 20.592f, 9.604f)
                curveTo(20.773f, 9.604f, 20.979f, 9.698f, 20.979f, 9.988f)
                curveTo(20.979f, 10.279f, 21.349f, 9.87f, 21.349f, 9.87f)
                verticalLineTo(11.079f)
                curveTo(21.349f, 11.079f, 21.435f, 11.21f, 21.625f, 11.079f)
                curveTo(21.815f, 10.948f, 21.732f, 11.05f, 21.162f, 11.817f)
                curveTo(20.592f, 12.583f, 20.797f, 12.585f, 20.979f, 12.398f)
                curveTo(21.162f, 12.21f, 21.902f, 11.676f, 21.625f, 11.943f)
                curveTo(21.349f, 12.21f, 21.33f, 12.769f, 21.625f, 12.583f)
                curveTo(21.92f, 12.398f, 21.863f, 12.265f, 21.863f, 12.583f)
                curveTo(21.863f, 12.901f, 21.344f, 13.983f, 21.162f, 14.152f)
                curveTo(20.979f, 14.322f, 20.809f, 14.426f, 20.592f, 14.596f)
                curveTo(20.374f, 14.767f, 20.13f, 14.968f, 20.13f, 15.09f)
                curveTo(20.13f, 15.212f, 20.592f, 14.959f, 20.592f, 14.959f)
                lineTo(20.374f, 15.735f)
                horizontalLineTo(20.797f)
                curveTo(20.797f, 15.735f, 20.461f, 16.767f, 19.799f, 16.767f)
                curveTo(19.137f, 16.767f, 18.639f, 16.767f, 18.506f, 16.767f)
                curveTo(18.373f, 16.767f, 17.772f, 17.05f, 17.772f, 17.05f)
                lineTo(17.333f, 17.175f)
                curveTo(17.333f, 17.175f, 18.033f, 17.242f, 18.27f, 17.452f)
                curveTo(18.506f, 17.662f, 18.27f, 17.809f, 18.27f, 17.809f)
                curveTo(18.27f, 17.809f, 17.621f, 17.745f, 17.137f, 17.598f)
                curveTo(16.653f, 17.452f, 16.407f, 17.729f, 16.407f, 17.452f)
                curveTo(16.407f, 17.175f, 16.407f, 17.175f, 16.407f, 17.175f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(20.783f, 8.909f)
                curveTo(20.783f, 9.009f, 20.705f, 9.091f, 20.609f, 9.091f)
                curveTo(20.513f, 9.091f, 20.435f, 9.009f, 20.435f, 8.909f)
                curveTo(20.435f, 8.809f, 20.513f, 8.727f, 20.609f, 8.727f)
                curveTo(20.705f, 8.727f, 20.783f, 8.809f, 20.783f, 8.909f)
                close()
                moveTo(19.913f, 9.636f)
                curveTo(19.913f, 9.737f, 19.835f, 9.818f, 19.739f, 9.818f)
                curveTo(19.643f, 9.818f, 19.565f, 9.737f, 19.565f, 9.636f)
                curveTo(19.565f, 9.536f, 19.643f, 9.455f, 19.739f, 9.455f)
                curveTo(19.835f, 9.455f, 19.913f, 9.536f, 19.913f, 9.636f)
                close()
                moveTo(20.783f, 9.455f)
                curveTo(20.879f, 9.455f, 20.956f, 9.373f, 20.956f, 9.273f)
                curveTo(20.956f, 9.172f, 20.879f, 9.091f, 20.783f, 9.091f)
                curveTo(20.687f, 9.091f, 20.609f, 9.172f, 20.609f, 9.273f)
                curveTo(20.609f, 9.373f, 20.687f, 9.455f, 20.783f, 9.455f)
                close()
                moveTo(20.435f, 12.182f)
                curveTo(20.435f, 12.282f, 20.357f, 12.364f, 20.261f, 12.364f)
                curveTo(20.165f, 12.364f, 20.087f, 12.282f, 20.087f, 12.182f)
                curveTo(20.087f, 12.081f, 20.165f, 12f, 20.261f, 12f)
                curveTo(20.357f, 12f, 20.435f, 12.081f, 20.435f, 12.182f)
                close()
                moveTo(19.565f, 14.545f)
                curveTo(19.661f, 14.545f, 19.739f, 14.464f, 19.739f, 14.364f)
                curveTo(19.739f, 14.263f, 19.661f, 14.182f, 19.565f, 14.182f)
                curveTo(19.469f, 14.182f, 19.391f, 14.263f, 19.391f, 14.364f)
                curveTo(19.391f, 14.464f, 19.469f, 14.545f, 19.565f, 14.545f)
                close()
                moveTo(20.956f, 14.909f)
                curveTo(20.956f, 15.009f, 20.879f, 15.091f, 20.783f, 15.091f)
                curveTo(20.687f, 15.091f, 20.609f, 15.009f, 20.609f, 14.909f)
                curveTo(20.609f, 14.809f, 20.687f, 14.727f, 20.783f, 14.727f)
                curveTo(20.879f, 14.727f, 20.956f, 14.809f, 20.956f, 14.909f)
                close()
                moveTo(21.13f, 14.727f)
                curveTo(21.226f, 14.727f, 21.304f, 14.646f, 21.304f, 14.545f)
                curveTo(21.304f, 14.445f, 21.226f, 14.364f, 21.13f, 14.364f)
                curveTo(21.034f, 14.364f, 20.956f, 14.445f, 20.956f, 14.545f)
                curveTo(20.956f, 14.646f, 21.034f, 14.727f, 21.13f, 14.727f)
                close()
                moveTo(21.13f, 12f)
                curveTo(21.13f, 12.1f, 21.053f, 12.182f, 20.956f, 12.182f)
                curveTo(20.861f, 12.182f, 20.783f, 12.1f, 20.783f, 12f)
                curveTo(20.783f, 11.9f, 20.861f, 11.818f, 20.956f, 11.818f)
                curveTo(21.053f, 11.818f, 21.13f, 11.9f, 21.13f, 12f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF00A854)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.686f, 16.855f)
                curveTo(15.686f, 16.855f, 12.922f, 16.308f, 12.771f, 15.251f)
                curveTo(12.62f, 14.194f, 12.622f, 13.068f, 12.622f, 13.068f)
                lineTo(12.365f, 13.756f)
                curveTo(12.365f, 13.756f, 12.352f, 12.82f, 12.878f, 12.152f)
                curveTo(13.404f, 11.484f, 12.221f, 12.595f, 12.221f, 12.595f)
                curveTo(12.221f, 12.595f, 12.82f, 11.65f, 13.069f, 11.56f)
                curveTo(13.319f, 11.47f, 12.068f, 12.152f, 12.068f, 12.152f)
                curveTo(12.068f, 12.152f, 12.426f, 11.36f, 12.705f, 11.136f)
                curveTo(12.983f, 10.911f, 12.068f, 11.56f, 12.068f, 11.56f)
                curveTo(12.068f, 11.56f, 12.275f, 10.775f, 12.522f, 10.587f)
                curveTo(12.77f, 10.4f, 11.713f, 11.56f, 11.713f, 11.56f)
                curveTo(11.713f, 11.56f, 12.271f, 9.765f, 12.585f, 9.597f)
                curveTo(12.899f, 9.43f, 12.068f, 9.926f, 12.068f, 9.926f)
                curveTo(12.068f, 9.926f, 12.577f, 9.158f, 13.033f, 8.777f)
                curveTo(13.49f, 8.395f, 12.208f, 8.939f, 12.365f, 8.939f)
                curveTo(12.365f, 8.939f, 12.829f, 8.416f, 13.095f, 8.269f)
                curveTo(13.361f, 8.121f, 12.068f, 8.777f, 12.068f, 8.777f)
                curveTo(12.068f, 8.777f, 12.996f, 7.752f, 13.274f, 7.601f)
                curveTo(13.553f, 7.45f, 11.908f, 8.415f, 11.908f, 8.415f)
                curveTo(11.908f, 8.415f, 12.004f, 7.968f, 12.045f, 7.649f)
                curveTo(12.087f, 7.329f, 11.283f, 8.524f, 11.392f, 9.597f)
                curveTo(11.502f, 10.67f, 10.955f, 8.777f, 10.955f, 8.777f)
                curveTo(10.955f, 8.777f, 10.736f, 9.188f, 11.27f, 10.265f)
                lineTo(10.691f, 9.454f)
                curveTo(10.691f, 9.454f, 10.77f, 10.19f, 10.955f, 10.587f)
                curveTo(11.141f, 10.984f, 10.429f, 9.926f, 10.429f, 9.926f)
                curveTo(10.429f, 9.926f, 10.293f, 10.587f, 10.429f, 10.587f)
                curveTo(10.429f, 10.587f, 11.242f, 11.673f, 11.272f, 11.99f)
                curveTo(11.302f, 12.306f, 10.359f, 10.859f, 10.233f, 10.859f)
                curveTo(10.107f, 10.859f, 10.037f, 11.324f, 10.233f, 11.324f)
                curveTo(10.429f, 11.324f, 10.8f, 11.99f, 10.8f, 11.99f)
                curveTo(10.8f, 11.99f, 10.318f, 11.641f, 10.214f, 11.62f)
                curveTo(10.111f, 11.599f, 10.295f, 11.827f, 10.429f, 11.99f)
                curveTo(10.429f, 11.99f, 10.052f, 12.297f, 10.08f, 12.531f)
                curveTo(10.109f, 12.764f, 11.109f, 12.813f, 11.545f, 13.92f)
                curveTo(11.545f, 13.92f, 10.644f, 13.444f, 10.429f, 13.444f)
                curveTo(10.214f, 13.444f, 10.775f, 13.941f, 10.955f, 14.106f)
                curveTo(11.136f, 14.27f, 10.677f, 13.941f, 10.553f, 14.106f)
                curveTo(10.429f, 14.27f, 11.24f, 14.972f, 11.392f, 14.972f)
                curveTo(11.545f, 14.972f, 10.8f, 14.972f, 10.8f, 14.972f)
                curveTo(10.8f, 14.972f, 10.998f, 15.251f, 11.272f, 15.251f)
                curveTo(11.545f, 15.251f, 12.522f, 15.69f, 12.522f, 15.833f)
                curveTo(12.522f, 15.975f, 11.698f, 15.651f, 11.545f, 15.651f)
                curveTo(11.392f, 15.651f, 12.622f, 16.81f, 13.274f, 16.855f)
                curveTo(13.927f, 16.899f, 14.34f, 17.074f, 14.621f, 17.074f)
                curveTo(14.903f, 17.074f, 15.101f, 17.074f, 15.101f, 17.074f)
                lineTo(13.771f, 17.752f)
                curveTo(13.771f, 17.752f, 13.637f, 17.752f, 14.214f, 17.752f)
                curveTo(14.79f, 17.752f, 15.232f, 17.912f, 15.459f, 17.581f)
                curveTo(15.686f, 17.249f, 15.686f, 16.855f, 15.686f, 16.855f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.087f, 8.905f)
                curveTo(16.113f, 8.89f, 16.128f, 8.882f, 16.128f, 8.882f)
                verticalLineTo(8.929f)
                curveTo(16.321f, 9.035f, 16.806f, 9.284f, 17.121f, 9.284f)
                curveTo(17.521f, 9.284f, 18.066f, 8.882f, 18.066f, 8.882f)
                lineTo(18.977f, 10.168f)
                curveTo(18.977f, 10.168f, 18.364f, 11.455f, 18.833f, 13.026f)
                curveTo(19.303f, 14.598f, 18.808f, 15.81f, 16.72f, 15.945f)
                curveTo(16.72f, 15.945f, 16.309f, 16.023f, 16.128f, 16.147f)
                verticalLineTo(16.263f)
                curveTo(16.128f, 16.234f, 16.113f, 16.207f, 16.087f, 16.181f)
                curveTo(16.061f, 16.207f, 16.045f, 16.234f, 16.045f, 16.263f)
                verticalLineTo(16.147f)
                curveTo(15.865f, 16.023f, 15.453f, 15.945f, 15.453f, 15.945f)
                curveTo(13.365f, 15.81f, 12.871f, 14.598f, 13.34f, 13.026f)
                curveTo(13.81f, 11.455f, 13.196f, 10.168f, 13.196f, 10.168f)
                lineTo(14.108f, 8.882f)
                curveTo(14.108f, 8.882f, 14.652f, 9.284f, 15.053f, 9.284f)
                curveTo(15.368f, 9.284f, 15.853f, 9.035f, 16.045f, 8.929f)
                verticalLineTo(8.882f)
                curveTo(16.045f, 8.882f, 16.06f, 8.89f, 16.087f, 8.905f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(11.177f, 6.881f)
                horizontalLineToRelative(9f)
                verticalLineToRelative(11f)
                horizontalLineToRelative(-9f)
                close()
                moveTo(16.087f, 8.905f)
                curveTo(16.113f, 8.89f, 16.128f, 8.882f, 16.128f, 8.882f)
                verticalLineTo(8.929f)
                curveTo(16.321f, 9.035f, 16.806f, 9.284f, 17.121f, 9.284f)
                curveTo(17.521f, 9.284f, 18.066f, 8.882f, 18.066f, 8.882f)
                lineTo(18.977f, 10.168f)
                curveTo(18.977f, 10.168f, 18.364f, 11.455f, 18.833f, 13.026f)
                curveTo(19.303f, 14.598f, 18.808f, 15.81f, 16.72f, 15.945f)
                curveTo(16.72f, 15.945f, 16.309f, 16.023f, 16.128f, 16.147f)
                verticalLineTo(16.263f)
                curveTo(16.128f, 16.234f, 16.113f, 16.207f, 16.087f, 16.181f)
                curveTo(16.061f, 16.207f, 16.045f, 16.234f, 16.045f, 16.263f)
                verticalLineTo(16.147f)
                curveTo(15.865f, 16.023f, 15.453f, 15.945f, 15.453f, 15.945f)
                curveTo(13.365f, 15.81f, 12.871f, 14.598f, 13.34f, 13.026f)
                curveTo(13.81f, 11.455f, 13.196f, 10.168f, 13.196f, 10.168f)
                lineTo(14.108f, 8.882f)
                curveTo(14.108f, 8.882f, 14.652f, 9.284f, 15.053f, 9.284f)
                curveTo(15.368f, 9.284f, 15.853f, 9.035f, 16.045f, 8.929f)
                verticalLineTo(8.882f)
                curveTo(16.045f, 8.882f, 16.06f, 8.89f, 16.087f, 8.905f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(16.128f, 8.882f)
                horizontalLineTo(17.128f)
                verticalLineTo(7.121f)
                lineTo(15.616f, 8.023f)
                lineTo(16.128f, 8.882f)
                close()
                moveTo(16.087f, 8.905f)
                lineTo(15.594f, 9.775f)
                lineTo(16.087f, 10.055f)
                lineTo(16.58f, 9.775f)
                lineTo(16.087f, 8.905f)
                close()
                moveTo(16.128f, 8.929f)
                horizontalLineTo(15.128f)
                verticalLineTo(9.519f)
                lineTo(15.645f, 9.804f)
                lineTo(16.128f, 8.929f)
                close()
                moveTo(18.066f, 8.882f)
                lineTo(18.882f, 8.304f)
                lineTo(18.292f, 7.471f)
                lineTo(17.472f, 8.077f)
                lineTo(18.066f, 8.882f)
                close()
                moveTo(18.977f, 10.168f)
                lineTo(19.88f, 10.599f)
                lineTo(20.132f, 10.069f)
                lineTo(19.793f, 9.59f)
                lineTo(18.977f, 10.168f)
                close()
                moveTo(18.833f, 13.026f)
                lineTo(17.875f, 13.313f)
                lineTo(18.833f, 13.026f)
                close()
                moveTo(16.72f, 15.945f)
                lineTo(16.656f, 14.947f)
                lineTo(16.594f, 14.951f)
                lineTo(16.533f, 14.962f)
                lineTo(16.72f, 15.945f)
                close()
                moveTo(16.128f, 16.147f)
                lineTo(15.56f, 15.325f)
                lineTo(15.128f, 15.623f)
                verticalLineTo(16.147f)
                horizontalLineTo(16.128f)
                close()
                moveTo(16.087f, 16.181f)
                lineTo(16.787f, 15.467f)
                lineTo(16.087f, 14.78f)
                lineTo(15.387f, 15.467f)
                lineTo(16.087f, 16.181f)
                close()
                moveTo(16.045f, 16.147f)
                horizontalLineTo(17.045f)
                verticalLineTo(15.623f)
                lineTo(16.614f, 15.325f)
                lineTo(16.045f, 16.147f)
                close()
                moveTo(15.453f, 15.945f)
                lineTo(15.64f, 14.962f)
                lineTo(15.58f, 14.951f)
                lineTo(15.518f, 14.947f)
                lineTo(15.453f, 15.945f)
                close()
                moveTo(13.196f, 10.168f)
                lineTo(12.38f, 9.59f)
                lineTo(12.041f, 10.069f)
                lineTo(12.294f, 10.599f)
                lineTo(13.196f, 10.168f)
                close()
                moveTo(14.108f, 8.882f)
                lineTo(14.702f, 8.077f)
                lineTo(13.881f, 7.471f)
                lineTo(13.291f, 8.304f)
                lineTo(14.108f, 8.882f)
                close()
                moveTo(16.045f, 8.929f)
                lineTo(16.528f, 9.804f)
                lineTo(17.045f, 9.519f)
                verticalLineTo(8.929f)
                horizontalLineTo(16.045f)
                close()
                moveTo(16.045f, 8.882f)
                lineTo(16.557f, 8.023f)
                lineTo(15.045f, 7.121f)
                verticalLineTo(8.882f)
                horizontalLineTo(16.045f)
                close()
                moveTo(16.128f, 8.882f)
                curveTo(15.616f, 8.023f, 15.616f, 8.023f, 15.616f, 8.023f)
                curveTo(15.616f, 8.023f, 15.616f, 8.023f, 15.616f, 8.023f)
                curveTo(15.616f, 8.023f, 15.616f, 8.022f, 15.616f, 8.022f)
                curveTo(15.616f, 8.022f, 15.616f, 8.022f, 15.616f, 8.022f)
                curveTo(15.616f, 8.022f, 15.617f, 8.022f, 15.617f, 8.022f)
                curveTo(15.617f, 8.022f, 15.617f, 8.022f, 15.617f, 8.022f)
                curveTo(15.617f, 8.022f, 15.617f, 8.022f, 15.618f, 8.022f)
                curveTo(15.618f, 8.022f, 15.618f, 8.022f, 15.618f, 8.022f)
                curveTo(15.617f, 8.022f, 15.616f, 8.023f, 15.614f, 8.024f)
                curveTo(15.61f, 8.026f, 15.603f, 8.03f, 15.594f, 8.035f)
                lineTo(16.58f, 9.775f)
                curveTo(16.597f, 9.766f, 16.611f, 9.758f, 16.621f, 9.752f)
                curveTo(16.626f, 9.749f, 16.63f, 9.747f, 16.633f, 9.745f)
                curveTo(16.635f, 9.744f, 16.636f, 9.743f, 16.638f, 9.742f)
                curveTo(16.638f, 9.742f, 16.639f, 9.741f, 16.639f, 9.741f)
                curveTo(16.639f, 9.741f, 16.639f, 9.741f, 16.64f, 9.741f)
                curveTo(16.64f, 9.741f, 16.64f, 9.741f, 16.64f, 9.741f)
                curveTo(16.64f, 9.741f, 16.64f, 9.741f, 16.64f, 9.741f)
                curveTo(16.64f, 9.741f, 16.64f, 9.741f, 16.64f, 9.74f)
                curveTo(16.64f, 9.74f, 16.64f, 9.74f, 16.64f, 9.74f)
                curveTo(16.64f, 9.74f, 16.64f, 9.74f, 16.128f, 8.882f)
                close()
                moveTo(17.128f, 8.929f)
                verticalLineTo(8.882f)
                horizontalLineTo(15.128f)
                verticalLineTo(8.929f)
                horizontalLineTo(17.128f)
                close()
                moveTo(15.645f, 9.804f)
                curveTo(15.759f, 9.867f, 15.965f, 9.976f, 16.2f, 10.072f)
                curveTo(16.403f, 10.155f, 16.756f, 10.284f, 17.121f, 10.284f)
                verticalLineTo(8.284f)
                curveTo(17.163f, 8.284f, 17.167f, 8.29f, 17.12f, 8.278f)
                curveTo(17.079f, 8.267f, 17.024f, 8.248f, 16.957f, 8.22f)
                curveTo(16.822f, 8.165f, 16.69f, 8.097f, 16.611f, 8.053f)
                lineTo(15.645f, 9.804f)
                close()
                moveTo(17.121f, 10.284f)
                curveTo(17.588f, 10.284f, 18.015f, 10.073f, 18.219f, 9.963f)
                curveTo(18.343f, 9.895f, 18.449f, 9.829f, 18.524f, 9.78f)
                curveTo(18.562f, 9.755f, 18.593f, 9.733f, 18.616f, 9.717f)
                curveTo(18.628f, 9.709f, 18.637f, 9.703f, 18.645f, 9.697f)
                curveTo(18.648f, 9.695f, 18.651f, 9.692f, 18.654f, 9.69f)
                curveTo(18.655f, 9.689f, 18.656f, 9.689f, 18.657f, 9.688f)
                curveTo(18.658f, 9.687f, 18.658f, 9.687f, 18.659f, 9.687f)
                curveTo(18.659f, 9.687f, 18.659f, 9.686f, 18.66f, 9.686f)
                curveTo(18.66f, 9.686f, 18.66f, 9.686f, 18.66f, 9.686f)
                curveTo(18.66f, 9.686f, 18.66f, 9.686f, 18.066f, 8.882f)
                curveTo(17.472f, 8.077f, 17.472f, 8.077f, 17.472f, 8.077f)
                curveTo(17.472f, 8.077f, 17.472f, 8.077f, 17.472f, 8.077f)
                curveTo(17.473f, 8.077f, 17.473f, 8.076f, 17.473f, 8.076f)
                curveTo(17.473f, 8.076f, 17.473f, 8.076f, 17.474f, 8.076f)
                curveTo(17.474f, 8.075f, 17.475f, 8.075f, 17.475f, 8.075f)
                curveTo(17.475f, 8.075f, 17.475f, 8.075f, 17.475f, 8.075f)
                curveTo(17.474f, 8.075f, 17.472f, 8.077f, 17.467f, 8.08f)
                curveTo(17.459f, 8.086f, 17.444f, 8.096f, 17.425f, 8.109f)
                curveTo(17.385f, 8.135f, 17.33f, 8.169f, 17.268f, 8.203f)
                curveTo(17.205f, 8.237f, 17.149f, 8.262f, 17.106f, 8.277f)
                curveTo(17.056f, 8.295f, 17.066f, 8.284f, 17.121f, 8.284f)
                verticalLineTo(10.284f)
                close()
                moveTo(17.25f, 9.459f)
                lineTo(18.161f, 10.746f)
                lineTo(19.793f, 9.59f)
                lineTo(18.882f, 8.304f)
                lineTo(17.25f, 9.459f)
                close()
                moveTo(18.977f, 10.168f)
                curveTo(18.075f, 9.738f, 18.075f, 9.738f, 18.074f, 9.738f)
                curveTo(18.074f, 9.738f, 18.074f, 9.739f, 18.074f, 9.739f)
                curveTo(18.074f, 9.74f, 18.074f, 9.74f, 18.073f, 9.741f)
                curveTo(18.073f, 9.742f, 18.072f, 9.743f, 18.072f, 9.744f)
                curveTo(18.07f, 9.747f, 18.069f, 9.749f, 18.068f, 9.752f)
                curveTo(18.065f, 9.759f, 18.061f, 9.766f, 18.058f, 9.775f)
                curveTo(18.049f, 9.793f, 18.04f, 9.816f, 18.028f, 9.843f)
                curveTo(18.005f, 9.899f, 17.976f, 9.974f, 17.944f, 10.067f)
                curveTo(17.879f, 10.252f, 17.803f, 10.512f, 17.745f, 10.828f)
                curveTo(17.63f, 11.458f, 17.584f, 12.339f, 17.875f, 13.313f)
                lineTo(19.791f, 12.74f)
                curveTo(19.613f, 12.142f, 19.639f, 11.593f, 19.713f, 11.188f)
                curveTo(19.75f, 10.986f, 19.798f, 10.825f, 19.834f, 10.721f)
                curveTo(19.852f, 10.668f, 19.867f, 10.631f, 19.875f, 10.61f)
                curveTo(19.88f, 10.599f, 19.883f, 10.593f, 19.883f, 10.591f)
                curveTo(19.884f, 10.59f, 19.884f, 10.59f, 19.883f, 10.592f)
                curveTo(19.883f, 10.592f, 19.882f, 10.593f, 19.882f, 10.594f)
                curveTo(19.882f, 10.595f, 19.881f, 10.596f, 19.881f, 10.596f)
                curveTo(19.881f, 10.597f, 19.881f, 10.597f, 19.88f, 10.597f)
                curveTo(19.88f, 10.598f, 19.88f, 10.598f, 19.88f, 10.598f)
                curveTo(19.88f, 10.599f, 19.88f, 10.599f, 18.977f, 10.168f)
                close()
                moveTo(17.875f, 13.313f)
                curveTo(18.073f, 13.974f, 17.994f, 14.327f, 17.89f, 14.491f)
                curveTo(17.804f, 14.627f, 17.535f, 14.89f, 16.656f, 14.947f)
                lineTo(16.784f, 16.943f)
                curveTo(17.994f, 16.865f, 19.016f, 16.454f, 19.581f, 15.558f)
                curveTo(20.13f, 14.69f, 20.063f, 13.651f, 19.791f, 12.74f)
                lineTo(17.875f, 13.313f)
                close()
                moveTo(16.72f, 15.945f)
                curveTo(16.533f, 14.962f, 16.533f, 14.962f, 16.533f, 14.962f)
                curveTo(16.533f, 14.962f, 16.533f, 14.962f, 16.533f, 14.962f)
                curveTo(16.533f, 14.962f, 16.533f, 14.962f, 16.532f, 14.962f)
                curveTo(16.532f, 14.962f, 16.532f, 14.963f, 16.531f, 14.963f)
                curveTo(16.531f, 14.963f, 16.53f, 14.963f, 16.529f, 14.963f)
                curveTo(16.527f, 14.964f, 16.524f, 14.964f, 16.522f, 14.965f)
                curveTo(16.516f, 14.966f, 16.509f, 14.967f, 16.501f, 14.969f)
                curveTo(16.484f, 14.972f, 16.461f, 14.977f, 16.434f, 14.983f)
                curveTo(16.381f, 14.995f, 16.306f, 15.013f, 16.222f, 15.036f)
                curveTo(16.097f, 15.072f, 15.801f, 15.158f, 15.56f, 15.325f)
                lineTo(16.697f, 16.97f)
                curveTo(16.649f, 17.003f, 16.626f, 17.008f, 16.659f, 16.995f)
                curveTo(16.683f, 16.986f, 16.718f, 16.974f, 16.761f, 16.962f)
                curveTo(16.803f, 16.951f, 16.843f, 16.941f, 16.872f, 16.935f)
                curveTo(16.886f, 16.931f, 16.897f, 16.929f, 16.903f, 16.928f)
                curveTo(16.906f, 16.927f, 16.908f, 16.927f, 16.909f, 16.927f)
                curveTo(16.909f, 16.927f, 16.909f, 16.927f, 16.909f, 16.927f)
                curveTo(16.909f, 16.927f, 16.908f, 16.927f, 16.908f, 16.927f)
                curveTo(16.908f, 16.927f, 16.908f, 16.927f, 16.907f, 16.927f)
                curveTo(16.907f, 16.927f, 16.907f, 16.927f, 16.907f, 16.927f)
                curveTo(16.907f, 16.927f, 16.907f, 16.927f, 16.907f, 16.927f)
                curveTo(16.907f, 16.927f, 16.907f, 16.927f, 16.72f, 15.945f)
                close()
                moveTo(17.128f, 16.263f)
                verticalLineTo(16.147f)
                horizontalLineTo(15.128f)
                verticalLineTo(16.263f)
                horizontalLineTo(17.128f)
                close()
                moveTo(15.387f, 16.895f)
                curveTo(15.316f, 16.826f, 15.128f, 16.612f, 15.128f, 16.263f)
                horizontalLineTo(17.128f)
                curveTo(17.128f, 15.856f, 16.909f, 15.587f, 16.787f, 15.467f)
                lineTo(15.387f, 16.895f)
                close()
                moveTo(15.387f, 15.467f)
                curveTo(15.264f, 15.587f, 15.045f, 15.856f, 15.045f, 16.263f)
                horizontalLineTo(17.045f)
                curveTo(17.045f, 16.612f, 16.857f, 16.826f, 16.787f, 16.895f)
                lineTo(15.387f, 15.467f)
                close()
                moveTo(17.045f, 16.263f)
                verticalLineTo(16.147f)
                horizontalLineTo(15.045f)
                verticalLineTo(16.263f)
                horizontalLineTo(17.045f)
                close()
                moveTo(15.453f, 15.945f)
                curveTo(15.267f, 16.927f, 15.267f, 16.927f, 15.267f, 16.927f)
                curveTo(15.267f, 16.927f, 15.267f, 16.927f, 15.266f, 16.927f)
                curveTo(15.266f, 16.927f, 15.266f, 16.927f, 15.266f, 16.927f)
                curveTo(15.266f, 16.927f, 15.266f, 16.927f, 15.266f, 16.927f)
                curveTo(15.265f, 16.927f, 15.265f, 16.927f, 15.265f, 16.927f)
                curveTo(15.264f, 16.927f, 15.264f, 16.927f, 15.265f, 16.927f)
                curveTo(15.265f, 16.927f, 15.267f, 16.927f, 15.271f, 16.928f)
                curveTo(15.277f, 16.929f, 15.288f, 16.931f, 15.302f, 16.935f)
                curveTo(15.331f, 16.941f, 15.37f, 16.951f, 15.412f, 16.962f)
                curveTo(15.455f, 16.974f, 15.491f, 16.986f, 15.514f, 16.995f)
                curveTo(15.547f, 17.008f, 15.524f, 17.003f, 15.477f, 16.97f)
                lineTo(16.614f, 15.325f)
                curveTo(16.372f, 15.158f, 16.077f, 15.072f, 15.951f, 15.036f)
                curveTo(15.868f, 15.013f, 15.793f, 14.995f, 15.739f, 14.983f)
                curveTo(15.712f, 14.977f, 15.689f, 14.972f, 15.673f, 14.969f)
                curveTo(15.664f, 14.967f, 15.657f, 14.966f, 15.652f, 14.965f)
                curveTo(15.649f, 14.964f, 15.647f, 14.964f, 15.645f, 14.963f)
                curveTo(15.644f, 14.963f, 15.643f, 14.963f, 15.642f, 14.963f)
                curveTo(15.642f, 14.963f, 15.641f, 14.962f, 15.641f, 14.962f)
                curveTo(15.641f, 14.962f, 15.641f, 14.962f, 15.641f, 14.962f)
                curveTo(15.641f, 14.962f, 15.64f, 14.962f, 15.64f, 14.962f)
                curveTo(15.64f, 14.962f, 15.64f, 14.962f, 15.453f, 15.945f)
                close()
                moveTo(12.382f, 12.74f)
                curveTo(12.11f, 13.651f, 12.044f, 14.69f, 12.592f, 15.558f)
                curveTo(13.158f, 16.454f, 14.18f, 16.865f, 15.389f, 16.943f)
                lineTo(15.518f, 14.947f)
                curveTo(14.639f, 14.89f, 14.37f, 14.627f, 14.283f, 14.491f)
                curveTo(14.18f, 14.327f, 14.101f, 13.974f, 14.299f, 13.313f)
                lineTo(12.382f, 12.74f)
                close()
                moveTo(13.196f, 10.168f)
                curveTo(12.294f, 10.599f, 12.293f, 10.599f, 12.293f, 10.598f)
                curveTo(12.293f, 10.598f, 12.293f, 10.598f, 12.293f, 10.597f)
                curveTo(12.293f, 10.597f, 12.293f, 10.597f, 12.292f, 10.596f)
                curveTo(12.292f, 10.596f, 12.292f, 10.595f, 12.292f, 10.594f)
                curveTo(12.291f, 10.593f, 12.29f, 10.592f, 12.29f, 10.592f)
                curveTo(12.29f, 10.59f, 12.29f, 10.59f, 12.29f, 10.591f)
                curveTo(12.291f, 10.593f, 12.294f, 10.599f, 12.298f, 10.61f)
                curveTo(12.307f, 10.631f, 12.322f, 10.668f, 12.34f, 10.721f)
                curveTo(12.376f, 10.825f, 12.424f, 10.986f, 12.461f, 11.188f)
                curveTo(12.535f, 11.593f, 12.561f, 12.142f, 12.382f, 12.74f)
                lineTo(14.299f, 13.313f)
                curveTo(14.59f, 12.339f, 14.543f, 11.458f, 14.428f, 10.828f)
                curveTo(14.37f, 10.512f, 14.294f, 10.252f, 14.23f, 10.067f)
                curveTo(14.198f, 9.974f, 14.168f, 9.899f, 14.145f, 9.843f)
                curveTo(14.134f, 9.816f, 14.124f, 9.793f, 14.116f, 9.775f)
                curveTo(14.112f, 9.766f, 14.109f, 9.759f, 14.106f, 9.752f)
                curveTo(14.104f, 9.749f, 14.103f, 9.747f, 14.102f, 9.744f)
                curveTo(14.101f, 9.743f, 14.101f, 9.742f, 14.1f, 9.741f)
                curveTo(14.1f, 9.74f, 14.1f, 9.74f, 14.099f, 9.739f)
                curveTo(14.099f, 9.739f, 14.099f, 9.738f, 14.099f, 9.738f)
                curveTo(14.099f, 9.738f, 14.099f, 9.738f, 13.196f, 10.168f)
                close()
                moveTo(13.291f, 8.304f)
                lineTo(12.38f, 9.59f)
                lineTo(14.012f, 10.746f)
                lineTo(14.924f, 9.459f)
                lineTo(13.291f, 8.304f)
                close()
                moveTo(15.053f, 8.284f)
                curveTo(15.108f, 8.284f, 15.117f, 8.295f, 15.067f, 8.277f)
                curveTo(15.024f, 8.262f, 14.969f, 8.237f, 14.905f, 8.203f)
                curveTo(14.844f, 8.169f, 14.788f, 8.135f, 14.748f, 8.109f)
                curveTo(14.729f, 8.096f, 14.715f, 8.086f, 14.706f, 8.08f)
                curveTo(14.702f, 8.077f, 14.699f, 8.075f, 14.698f, 8.075f)
                curveTo(14.698f, 8.075f, 14.698f, 8.075f, 14.699f, 8.075f)
                curveTo(14.699f, 8.075f, 14.699f, 8.075f, 14.7f, 8.076f)
                curveTo(14.7f, 8.076f, 14.7f, 8.076f, 14.701f, 8.076f)
                curveTo(14.701f, 8.076f, 14.701f, 8.077f, 14.701f, 8.077f)
                curveTo(14.701f, 8.077f, 14.701f, 8.077f, 14.701f, 8.077f)
                curveTo(14.701f, 8.077f, 14.702f, 8.077f, 14.108f, 8.882f)
                curveTo(13.513f, 9.686f, 13.514f, 9.686f, 13.514f, 9.686f)
                curveTo(13.514f, 9.686f, 13.514f, 9.686f, 13.514f, 9.686f)
                curveTo(13.514f, 9.686f, 13.514f, 9.687f, 13.515f, 9.687f)
                curveTo(13.515f, 9.687f, 13.516f, 9.687f, 13.516f, 9.688f)
                curveTo(13.517f, 9.689f, 13.518f, 9.689f, 13.519f, 9.69f)
                curveTo(13.522f, 9.692f, 13.525f, 9.695f, 13.529f, 9.697f)
                curveTo(13.536f, 9.703f, 13.546f, 9.709f, 13.557f, 9.717f)
                curveTo(13.58f, 9.733f, 13.611f, 9.755f, 13.649f, 9.78f)
                curveTo(13.724f, 9.829f, 13.83f, 9.895f, 13.955f, 9.963f)
                curveTo(14.159f, 10.073f, 14.585f, 10.284f, 15.053f, 10.284f)
                verticalLineTo(8.284f)
                close()
                moveTo(15.562f, 8.053f)
                curveTo(15.483f, 8.097f, 15.351f, 8.165f, 15.217f, 8.22f)
                curveTo(15.15f, 8.248f, 15.094f, 8.267f, 15.054f, 8.278f)
                curveTo(15.007f, 8.29f, 15.011f, 8.284f, 15.053f, 8.284f)
                verticalLineTo(10.284f)
                curveTo(15.417f, 10.284f, 15.771f, 10.155f, 15.974f, 10.072f)
                curveTo(16.208f, 9.976f, 16.415f, 9.867f, 16.528f, 9.804f)
                lineTo(15.562f, 8.053f)
                close()
                moveTo(17.045f, 8.929f)
                verticalLineTo(8.882f)
                horizontalLineTo(15.045f)
                verticalLineTo(8.929f)
                horizontalLineTo(17.045f)
                close()
                moveTo(16.045f, 8.882f)
                curveTo(15.533f, 9.74f, 15.533f, 9.74f, 15.533f, 9.74f)
                curveTo(15.533f, 9.74f, 15.533f, 9.74f, 15.533f, 9.74f)
                curveTo(15.533f, 9.741f, 15.533f, 9.741f, 15.533f, 9.741f)
                curveTo(15.533f, 9.741f, 15.533f, 9.741f, 15.533f, 9.741f)
                curveTo(15.534f, 9.741f, 15.534f, 9.741f, 15.534f, 9.741f)
                curveTo(15.534f, 9.741f, 15.534f, 9.741f, 15.534f, 9.741f)
                curveTo(15.535f, 9.741f, 15.535f, 9.742f, 15.536f, 9.742f)
                curveTo(15.537f, 9.743f, 15.539f, 9.744f, 15.54f, 9.745f)
                curveTo(15.543f, 9.747f, 15.548f, 9.749f, 15.553f, 9.752f)
                curveTo(15.563f, 9.758f, 15.577f, 9.766f, 15.594f, 9.775f)
                lineTo(16.58f, 8.035f)
                curveTo(16.57f, 8.03f, 16.563f, 8.026f, 16.559f, 8.024f)
                curveTo(16.557f, 8.023f, 16.556f, 8.022f, 16.556f, 8.022f)
                curveTo(16.556f, 8.022f, 16.556f, 8.022f, 16.556f, 8.022f)
                curveTo(16.556f, 8.022f, 16.556f, 8.022f, 16.556f, 8.022f)
                curveTo(16.557f, 8.022f, 16.557f, 8.022f, 16.557f, 8.022f)
                curveTo(16.557f, 8.022f, 16.557f, 8.022f, 16.557f, 8.022f)
                curveTo(16.557f, 8.022f, 16.557f, 8.022f, 16.557f, 8.022f)
                curveTo(16.557f, 8.022f, 16.557f, 8.023f, 16.557f, 8.023f)
                curveTo(16.557f, 8.023f, 16.557f, 8.023f, 16.557f, 8.023f)
                curveTo(16.557f, 8.023f, 16.557f, 8.023f, 16.045f, 8.882f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(11.177f, 6.881f)
                horizontalLineToRelative(9f)
                verticalLineToRelative(11f)
                horizontalLineToRelative(-9f)
                close()
                moveTo(16.087f, 8.905f)
                curveTo(16.113f, 8.89f, 16.128f, 8.882f, 16.128f, 8.882f)
                verticalLineTo(8.929f)
                curveTo(16.321f, 9.035f, 16.806f, 9.284f, 17.121f, 9.284f)
                curveTo(17.521f, 9.284f, 18.066f, 8.882f, 18.066f, 8.882f)
                lineTo(18.977f, 10.168f)
                curveTo(18.977f, 10.168f, 18.364f, 11.455f, 18.833f, 13.026f)
                curveTo(19.303f, 14.598f, 18.808f, 15.81f, 16.72f, 15.945f)
                curveTo(16.72f, 15.945f, 16.309f, 16.023f, 16.128f, 16.147f)
                verticalLineTo(16.263f)
                curveTo(16.128f, 16.234f, 16.113f, 16.207f, 16.087f, 16.181f)
                curveTo(16.061f, 16.207f, 16.045f, 16.234f, 16.045f, 16.263f)
                verticalLineTo(16.147f)
                curveTo(15.865f, 16.023f, 15.453f, 15.945f, 15.453f, 15.945f)
                curveTo(13.365f, 15.81f, 12.871f, 14.598f, 13.34f, 13.026f)
                curveTo(13.81f, 11.455f, 13.196f, 10.168f, 13.196f, 10.168f)
                lineTo(14.108f, 8.882f)
                curveTo(14.108f, 8.882f, 14.652f, 9.284f, 15.053f, 9.284f)
                curveTo(15.368f, 9.284f, 15.853f, 9.035f, 16.045f, 8.929f)
                verticalLineTo(8.882f)
                curveTo(16.045f, 8.882f, 16.06f, 8.89f, 16.087f, 8.905f)
                close()
                moveTo(16.087f, 8.905f)
                curveTo(16.113f, 8.89f, 16.128f, 8.882f, 16.128f, 8.882f)
                verticalLineTo(8.929f)
                curveTo(16.321f, 9.035f, 16.806f, 9.284f, 17.121f, 9.284f)
                curveTo(17.521f, 9.284f, 18.066f, 8.882f, 18.066f, 8.882f)
                lineTo(18.977f, 10.168f)
                curveTo(18.977f, 10.168f, 18.364f, 11.455f, 18.833f, 13.026f)
                curveTo(19.303f, 14.598f, 18.808f, 15.81f, 16.72f, 15.945f)
                curveTo(16.72f, 15.945f, 16.309f, 16.023f, 16.128f, 16.147f)
                verticalLineTo(16.263f)
                curveTo(16.128f, 16.234f, 16.113f, 16.207f, 16.087f, 16.181f)
                curveTo(16.061f, 16.207f, 16.045f, 16.234f, 16.045f, 16.263f)
                verticalLineTo(16.147f)
                curveTo(15.865f, 16.023f, 15.453f, 15.945f, 15.453f, 15.945f)
                curveTo(13.365f, 15.81f, 12.871f, 14.598f, 13.34f, 13.026f)
                curveTo(13.81f, 11.455f, 13.196f, 10.168f, 13.196f, 10.168f)
                lineTo(14.108f, 8.882f)
                curveTo(14.108f, 8.882f, 14.652f, 9.284f, 15.053f, 9.284f)
                curveTo(15.368f, 9.284f, 15.853f, 9.035f, 16.045f, 8.929f)
                verticalLineTo(8.882f)
                curveTo(16.045f, 8.882f, 16.06f, 8.89f, 16.087f, 8.905f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF67BAFF))) {
                moveTo(13.304f, 8.727f)
                horizontalLineToRelative(2.783f)
                verticalLineToRelative(3.818f)
                horizontalLineToRelative(-2.783f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(16.087f, 8.727f)
                horizontalLineToRelative(2.783f)
                verticalLineToRelative(3.818f)
                horizontalLineToRelative(-2.783f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC51918))) {
                moveTo(12.957f, 12.909f)
                horizontalLineToRelative(6.957f)
                verticalLineToRelative(4.364f)
                horizontalLineToRelative(-6.957f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(17.435f, 12.275f)
                horizontalLineTo(17.087f)
                verticalLineTo(9.66f)
                horizontalLineTo(17.435f)
                verticalLineTo(12.275f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(17.294f, 11.086f)
                lineTo(17.124f, 11.389f)
                lineTo(16.524f, 11.054f)
                lineTo(16.693f, 10.75f)
                lineTo(17.294f, 11.086f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(17.294f, 10.358f)
                lineTo(17.124f, 10.662f)
                lineTo(16.524f, 10.327f)
                lineTo(16.693f, 10.023f)
                lineTo(17.294f, 10.358f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(17.219f, 11.086f)
                lineTo(17.389f, 11.389f)
                lineTo(17.989f, 11.054f)
                lineTo(17.82f, 10.75f)
                lineTo(17.219f, 11.086f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(17.219f, 10.358f)
                lineTo(17.389f, 10.662f)
                lineTo(17.989f, 10.327f)
                lineTo(17.82f, 10.023f)
                lineTo(17.219f, 10.358f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFBCD17)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(17.729f, 13.705f)
                curveTo(17.729f, 13.705f, 17.971f, 13.428f, 17.971f, 13.567f)
                curveTo(17.971f, 13.705f, 17.971f, 13.938f, 17.85f, 13.938f)
                curveTo(17.729f, 13.938f, 17.166f, 13.827f, 16.951f, 13.567f)
                curveTo(16.736f, 13.306f, 16.282f, 12.853f, 15.697f, 12.96f)
                curveTo(15.113f, 13.067f, 14.419f, 13.825f, 14.248f, 13.825f)
                curveTo(14.077f, 13.825f, 13.703f, 14.409f, 13.975f, 14.865f)
                curveTo(14.248f, 15.321f, 14.712f, 15.18f, 14.712f, 15.312f)
                curveTo(14.712f, 15.444f, 14.828f, 15.46f, 15.263f, 15.46f)
                curveTo(15.697f, 15.46f, 15.856f, 15.613f, 16.232f, 15.613f)
                curveTo(16.608f, 15.613f, 16.108f, 15.607f, 16.714f, 15.46f)
                curveTo(17.32f, 15.312f, 17.779f, 14.865f, 17.426f, 14.865f)
                curveTo(17.073f, 14.865f, 16.959f, 14.865f, 16.714f, 14.865f)
                curveTo(16.469f, 14.865f, 15.925f, 15.041f, 15.925f, 14.865f)
                curveTo(15.925f, 14.689f, 16.046f, 14.311f, 16.38f, 14.5f)
                curveTo(16.714f, 14.689f, 17.642f, 14.833f, 17.971f, 14.5f)
                curveTo(18.3f, 14.167f, 18.415f, 13.967f, 18.358f, 13.567f)
                curveTo(18.3f, 13.166f, 17.85f, 13.281f, 17.85f, 13.281f)
                lineTo(17.729f, 13.705f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFD18219)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.376f, 9.57f)
                curveTo(15.166f, 9.753f, 15.302f, 10.424f, 14.958f, 10.424f)
                curveTo(14.615f, 10.424f, 14.131f, 9.922f, 14.009f, 10.253f)
                curveTo(13.888f, 10.584f, 14.009f, 10.473f, 14.009f, 10.755f)
                curveTo(14.009f, 11.037f, 13.718f, 11.82f, 13.864f, 11.953f)
                curveTo(14.009f, 12.085f, 14.159f, 12.434f, 14.133f, 12.271f)
                curveTo(14.107f, 12.108f, 13.997f, 11.868f, 14.043f, 11.607f)
                curveTo(13.998f, 11.338f, 14.288f, 11.079f, 14.288f, 11.079f)
                curveTo(14.288f, 11.079f, 14.257f, 11.358f, 14.234f, 11.462f)
                curveTo(14.234f, 11.462f, 14.138f, 11.673f, 14.177f, 11.813f)
                curveTo(14.177f, 11.813f, 14.276f, 12.207f, 14.316f, 12.234f)
                curveTo(14.316f, 12.234f, 14.342f, 11.301f, 14.372f, 11.147f)
                curveTo(14.402f, 10.994f, 14.615f, 11.321f, 14.686f, 11.284f)
                curveTo(14.686f, 11.284f, 14.711f, 11.922f, 14.674f, 11.998f)
                curveTo(14.674f, 11.998f, 14.599f, 12.148f, 14.627f, 12.196f)
                curveTo(14.627f, 12.196f, 14.696f, 12.371f, 14.755f, 12.32f)
                curveTo(14.755f, 12.32f, 14.757f, 12.317f, 14.787f, 12.147f)
                curveTo(14.787f, 12.147f, 14.752f, 12.044f, 14.807f, 11.81f)
                curveTo(14.807f, 11.81f, 14.865f, 11.296f, 14.888f, 11.408f)
                curveTo(14.888f, 11.408f, 14.878f, 11.65f, 14.905f, 11.776f)
                curveTo(14.905f, 11.776f, 14.949f, 12.087f, 14.958f, 12.121f)
                curveTo(14.958f, 12.121f, 15.167f, 12.42f, 15.173f, 12.293f)
                curveTo(15.173f, 12.293f, 14.972f, 12.053f, 15.015f, 11.871f)
                curveTo(15.015f, 11.871f, 14.9f, 11.354f, 15.061f, 11.238f)
                curveTo(15.061f, 11.238f, 15.487f, 11.041f, 15.513f, 10.703f)
                curveTo(15.513f, 10.703f, 15.575f, 10.318f, 15.586f, 10.142f)
                curveTo(15.586f, 10.142f, 15.492f, 10.09f, 15.686f, 9.999f)
                curveTo(15.686f, 9.999f, 15.997f, 9.879f, 15.803f, 9.713f)
            }
        }
    }.build()
}

@Preview
@Composable
private fun PeruPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Peru,
            contentDescription = "Peru Flag"
        )
    }
}
